import React from 'react';
import { Typography, Paper, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ContentPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
}));

const ContentTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  marginBottom: theme.spacing(1),
  color: theme.palette.primary.main,
}));

const ContentText = styled(Typography)(({ theme }) => ({
  whiteSpace: 'pre-wrap',
}));

const ContentDisplay = ({ content }) => {
  const [title, ...contentLines] = content.split('<br>');

  return (
    <ContentPaper elevation={3}>
      <ContentTitle variant="h6">{title}</ContentTitle>
      <Box>
        {contentLines.map((line, index) => (
          <ContentText key={index} variant="body1" paragraph>
            {line.trim()}
          </ContentText>
        ))}
      </Box>
    </ContentPaper>
  );
};

export default ContentDisplay;
